import { render } from "./BcnReport.vue?vue&type=template&id=0bc4e2e2&ts=true"
import script from "./BcnReport.vue?vue&type=script&lang=ts"
export * from "./BcnReport.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__